import { useEffect, useState } from "react";

export const BYPASS_ON_PASSWORD = "debugon"; // NOSONAR - intentional bypass code to pre-test app
export const BYPASS_OFF_PASSWORD = "debugoff"; // NOSONAR - intentional bypass code to pre-test app
export const CAPTURE_TIMEOUT_MS = 2000;

export function useMaintenanceBypass() {
  const [isBypassed, setIsBypassed] = useState(false);

  useEffect(() => {
    let isCapturing = false;
    let buffer = "";
    let captureTimer: number | undefined;

    function resetCapture() {
      isCapturing = false;
      buffer = "";
      if (captureTimer !== undefined) globalThis.clearTimeout(captureTimer);
      captureTimer = undefined;
    }

    function trySubmit(input: string) {
      if (input === BYPASS_ON_PASSWORD) {
        setIsBypassed(true);
      } else if (input === BYPASS_OFF_PASSWORD) {
        setIsBypassed(false);
      }
      resetCapture();
    }

    function scheduleAutoSubmit() {
      if (captureTimer !== undefined) globalThis.clearTimeout(captureTimer);
      captureTimer = globalThis.setTimeout(() => {
        trySubmit(buffer);
      }, CAPTURE_TIMEOUT_MS) as unknown as number;
    }

    function handleKeyDown(e: KeyboardEvent) {
      if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
        resetCapture();
        isCapturing = true;
        return;
      }

      if (!isCapturing) return;

      if (e.key === "Escape") {
        resetCapture();
        return;
      }

      if (e.key.length === 1) {
        buffer += e.key;

        if (buffer === BYPASS_ON_PASSWORD || buffer === BYPASS_OFF_PASSWORD) {
          if (captureTimer !== undefined) globalThis.clearTimeout(captureTimer);
          trySubmit(buffer);
          return;
        }

        scheduleAutoSubmit();
      }
    }

    globalThis.addEventListener("keydown", handleKeyDown);
    return () => {
      globalThis.removeEventListener("keydown", handleKeyDown);
      if (captureTimer !== undefined) globalThis.clearTimeout(captureTimer);
    };
  }, []);

  return isBypassed;
}
